// extracted by mini-css-extract-plugin
export default {"feedback":"FeedbackMessage_feedback__KyoI-"};